import React from 'react';
import ReactDOM from 'react-dom';

interface Props {
  mountId: string;
  children: React.ReactNode;
}

export const Portal: React.FC<Props> = ({ mountId, children }) => {
  const [mounted, setMounted] = React.useState<boolean>(false);
  if (typeof window !== 'undefined') {
    const productAppEle = document.getElementById(mountId);

    if (!mounted && productAppEle) {
      productAppEle.innerHTML = '';
      setMounted(true);
    }

    return productAppEle ? ReactDOM.createPortal(children, productAppEle) : <React.Fragment />;
  }

  return <React.Fragment />;
};

export default Portal;
